export default {
  lang: "zh",
  关于: "关于",
  角色: "角色",
  公告: "公告",
  NFT: "NFT",
  币安顺风车: "币安顺风车",
  发布行程: "发布行程",
  获取最新资讯: "获取最新资讯",
  立即加入社区: "立即加入社群",
  购买: "购买",
  "币安顺风车平台 是一个结合了区块链技术与绿色出行理念的创新项目。它通过顺风车、步行和公共交通等多种方式，让用户不仅享受便捷的出行，还可以赚取币安顺风车代币奖励，实现经济收益。凭借其多样化的奖励机制、NFT 系统和长期的代币分配模型，币安顺风车平台 为用户提供了一个独特的「边走边赚」的机会。展望未来，币安顺风车平台 有望成为区块链领域中出行类应用的先锋，吸引越来越多的用户加入并从中受益。在全球环境问题日益严重的背景下，币安顺风车平台 的绿色出行理念也符合可持续发展的趋势，既为用户带来便利，又为环境保护贡献力量。":
    "币安顺风车平台 是一个结合了区块链技术与绿色出行理念的创新项目。它通过顺风车、步行和公共交通等多种方式，让用户不仅享受便捷的出行，还可以赚取币安顺风车代币奖励，实现经济收益。凭借其多样化的奖励机制、NFT 系统和长期的代币分配模型，币安顺风车平台 为用户提供了一个独特的「边走边赚」的机会。展望未来，币安顺风车平台 有望成为区块链领域中出行类应用的先锋，吸引越来越多的用户加入并从中受益。在全球环境问题日益严重的背景下，币安顺风车平台 的绿色出行理念也符合可持续发展的趋势，既为用户带来便利，又为环境保护贡献力量。",
  "日常行程赚取 币安顺风车": "日常行程赚取 币安顺风车",
  "在 币安顺风车平台 项目中，用户可以通过完成顺风车、步行或使用公共交通来赚取 币安顺风车 代币。行程的奖励基于“打卡点”机制，奖励取决于打卡点的数量和每个打卡点的奖励值。":
    "在 币安顺风车平台 项目中，用户可以通过完成顺风车、步行或使用公共交通来赚取 币安顺风车 代币。行程的奖励基于“打卡点”机制，奖励取决于打卡点的数量和每个打卡点的奖励值。",
  单个行程的奖励规则: "单个行程的奖励规则",
  "奖励计算公式：行程奖励 = 打卡点数量 × 单个打卡点奖励值":
    "奖励计算公式：行程奖励 = 打卡点数量 × 单个打卡点奖励值",
  "单个打卡点奖励值：公式：个人奖励基数 × (个人质押数量÷10,000)¹/⁴ 说明：个人奖励基数随全网总质押量动态变化调整，且全网每日奖励总额上限为 5,120 枚。":
    "单个打卡点奖励值：公式：个人奖励基数 × (个人质押数量÷10,000)¹/⁴ \n说明：个人奖励基数随全网总质押量动态变化调整，且全网每日奖励总额上限为 5,120 枚。",
  顺风车司机: "顺风车司机",
  "每日可获得额外 2 个行程次数": "每日可获得额外 2 个行程次数",
  出行达人: "出行达人",
  "每日可获得 5 个额外行程次数": "每日可获得 5 个额外行程次数",
  车队老板: "车队老板",
  "每日可获得 100 个额外行程次数，可以将行程次数赠送给好友":
    "每日可获得 100 个额外行程次数，可以将行程次数赠送给好友",
  城市合伙人: "城市合伙人",
  "每日可获得 1000 个额外行程次数，可以将行程次数赠送给好友":
    "每日可获得 1000 个额外行程次数，可以将行程次数赠送给好友",
  车主汽车NFT: "车主汽车NFT",
  新星之驾: "新星之驾",
  银翼之旅: "银翼之旅",
  金辉之路: "金辉之路",
  耀世之行: "耀世之行",
  传奇之旅: "传奇之旅",
  非车主服饰NFT: "非车主服饰NFT",
  普通款: "普通款",
  晨曦之装: "晨曦之装",
  霞光之服: "霞光之服",
  月华之衣: "月华之衣",
  日曜之袍: "日曜之袍",
  免费: "免费",
  打点奖励基数: "打点奖励基数",
  "币安顺风车 Token 简介": "币安顺风车 Token 简介",
  "概述 币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。 核心参数 • 代币标准：BEP-20（BSC） • 最大供应：1,000,000,000 • 启动即焚毁：700,000,000（链上可查） • 启动后剩余供应：300,000,000（其中 200,000,000 锁定用于行程挖矿奖励，非流通） 产出与奖励机制 • 行程奖励=打卡点数量 × 单个打卡点奖励值 • 单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4) • 个人奖励基数随全网总质押量动态调整 • 全网单日奖励总上限：5,120 枚 公平发射与官方参与 • 零预售、零预留、零私募；全程公开透明 • 官方通过 four.meme 公平购入 218,888,888 枚： – 200,000,000 枚锁入智能合约用于“行程挖矿” – 10,000,000 枚用于平台内积分兑换 – 8,888,888 枚用于社区活动与生态激励 • 绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查 团队长计划 • 全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB • 预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰 • 公平发射分配（核心 60,000,000 枚）： – 42,000,000 枚按投入比例分配 – 18,000,000 枚作为“团队长特殊贡献奖” • 前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权 团队长计划官方唯一地址： 0xbc74845Ea341F1203704b2CDcEDEE27060260605 代币用途与价值 • 出行激励：完成有效行程获得代币 • 权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等 • 生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为":
    "概述 币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。 核心参数 • 代币标准：BEP-20（BSC） • 最大供应：1,000,000,000 • 启动即焚毁：700,000,000（链上可查） • 启动后剩余供应：300,000,000（其中 200,000,000 锁定用于行程挖矿奖励，非流通） 产出与奖励机制 • 行程奖励=打卡点数量 × 单个打卡点奖励值 • 单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4) • 个人奖励基数随全网总质押量动态调整 • 全网单日奖励总上限：5,120 枚 公平发射与官方参与 • 零预售、零预留、零私募；全程公开透明 • 官方通过 four.meme 公平购入 218,888,888 枚： – 200,000,000 枚锁入智能合约用于“行程挖矿” – 10,000,000 枚用于平台内积分兑换 – 8,888,888 枚用于社区活动与生态激励 • 绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查 团队长计划 • 全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB • 预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰 • 公平发射分配（核心 60,000,000 枚）： – 42,000,000 枚按投入比例分配 – 18,000,000 枚作为“团队长特殊贡献奖” • 前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权 团队长计划官方唯一地址： 0xbc74845Ea341F1203704b2CDcEDEE27060260605 代币用途与价值 • 出行激励：完成有效行程获得代币 • 权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等 • 生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为",
  "在STON.FI上购买": "在STON.FI上购买",

  概述: "概述",
  "币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。":
    "币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。",
  核心参数: "核心参数",
  "代币标准：BEP-20（BSC）": "代币标准：BEP-20（BSC）",
  "最大供应：1,000M": "最大供应：1,000M",
  "启动即焚毁：432.46M（链上可查）": "启动即焚毁：432.46M（链上可查）",
  "启动后剩余供应：567M": "启动后剩余供应：567M",
  "– 其中 200M 锁定用于行程挖矿奖励，非流通":
    "– 其中 200M 锁定用于行程挖矿奖励，非流通",
  "– 其中 10M 锁定用于积分兑换等": "– 其中 10M 锁定用于积分兑换等",
  产出与奖励机制: "产出与奖励机制",
  "行程奖励=打卡点数量 × 单个打卡点奖励值":
    "行程奖励=打卡点数量 × 单个打卡点奖励值",
  "单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4)":
    "单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4)",
  个人奖励基数随全网总质押量动态调整: "个人奖励基数随全网总质押量动态调整",
  "全网单日奖励总上限：5,120 枚": "全网单日奖励总上限：5,120 枚",
  公平发射与官方参与: "公平发射与官方参与",
  "零预售、零预留、零私募；全程公开透明":
    "零预售、零预留、零私募；全程公开透明",
  "官方通过 four.meme 公平购入 210M 枚：":
    "官方通过 four.meme 公平购入 210M 枚：",
  "– 200M 枚锁入智能合约用于“行程挖矿”": "– 200M 枚锁入智能合约用于“行程挖矿”",
  "– 10M 枚用于平台内积分兑换": "– 10M 枚用于平台内积分兑换",
  "– 8,888,888 枚用于社区活动与生态激励":
    "– 8,888,888 枚用于社区活动与生态激励",
  "绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查":
    "绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查",
  团队长计划: "团队长计划",
  "全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB":
    "全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB",
  "预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰":
    "预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰",
  "公平发射分配（核心 60,000,000 枚）：":
    "公平发射分配（核心 60,000,000 枚）：",
  "– 42,000,000 枚按投入比例分配": "– 42,000,000 枚按投入比例分配",
  "– 18,000,000 枚作为“团队长特殊贡献奖”":
    "– 18,000,000 枚作为“团队长特殊贡献奖”",
  "前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权":
    "前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权",
  "团队长计划官方唯一地址：": "团队长计划官方唯一地址：",
  代币用途与价值: "代币用途与价值",
  "出行激励：完成有效行程获得代币": "出行激励：完成有效行程获得代币",
  "权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等":
    "权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等",
  "生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为":
    "生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为",
};
